import Swiper from 'swiper';

import BaseControl from "scripts/base-control";

import heroBannerSlider from "./hero-banner-slider.stache";
import heroBannerSliderPagination from "./hero-banner-slider-pagination.stache";

const IS_ACTIVE_CLASS = "is-active";

export const HeroBannerModule = BaseControl.extend({
    swiper: null,

    init() {
        this._super();
        this.$heroBanner = this.$element.find(".hero-banner");
        this.cards = this.getHeroBannerCardsData();
        this.autoRotationInterval = this.cards.length > 1 && this.$element.attr("auto-rotation-interval");

        this.buildMarkup();
        this.initSwiper();
    },

    getHeroBannerCardsData() {
        try {
            return JSON.parse(this.$element.attr("cards"));
        } catch (error) {
            console.error("[HeroBannerModule] Error parsing cards:\n", error);
            return [];
        }
    },

    buildMarkup() {
        const slides = this.cards.map((card) => ({
            ...card,
            isVideoCard: card.type === "videoCard",
            target: ["new", 'newWindow'].includes(card.shareUrlTarget) ? "_blank" : "_self",
            contentUrl: card.contentUrl || card.shareUrl
        }));
        this.$heroBanner.append(heroBannerSlider({slides}));
        this.$heroBanner.append(heroBannerSliderPagination({slides}));
    },

    initSwiper() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }

        this.$slider = this.$heroBanner.find(".hero-banner__slider");
        const autoRotationInterval = this.autoRotationInterval ? {
            autoplay: {
                delay: parseInt(this.autoRotationInterval),
                disableOnInteraction: true
            }
        } : {};

        setTimeout(() => {
            this.swiper = new Swiper(this.$slider, {
                slidesPerView: 1,
                autoHeight: true,
                draggable: true,
                speed: 700,
                longSwipesRatio: 0.7,
                ...autoRotationInterval,
                loop: true,
                navigation: false,
                observer: true,
                observeParents: true,
                watchSlidesProgress: true,
                preloadImages: false,
                on: {
                    realIndexChange: () => {
                        this.pauseActiveVideo();
                        this.setNextItemTitle();
                        this.setPaginationActiveItem();
                        this.updateSwiperLoop();
                    },
                }
            });
            this.initPagination();
        }, 0);
    },

    // Fix images and videos not being visible when the user is at the end or beginning of the swiper loop manually
    updateSwiperLoop() {
        if (!this.swiper) return;

        if (this.swiper.isEnd) {
            this.swiper.loopDestroy();
            this.swiper.loopCreate();
        }
        if (this.swiper.isBeginning) {
            this.swiper.loopDestroy();
            this.swiper.loopCreate();
        }
    },

    initPagination() {
        this.$pagination = this.$heroBanner.find(".js-hero-banner-pagination");
        this.$nextItemTitle = this.$pagination.find(".js-hero-banner-next-item-title");

        this.setNextItemTitle();
        this.setPaginationActiveItem();

        this.$pagination.find(".js-hero-banner-button").on("click", (e) => {
            const $item = $(e.currentTarget);
            const index = $item.data("slideIndex");

            this.swiper?.slideTo(index + 1);
            this.setPaginationActiveItem();
        });
    },


    setNextItemTitle() {
        if (!this.swiper || !this.cards?.length) {
            return;
        }

        const nextItemIndex = this.getNextItemIndex();
        const nextCard = this.cards[nextItemIndex];

        if (nextCard?.title) {
            this.$nextItemTitle.text(`Next: ${nextCard.title}`);
        }
    },

    setPaginationActiveItem() {
        this.$pagination.find(".js-hero-banner-button").removeClass(IS_ACTIVE_CLASS);
        this.$pagination.find(".js-hero-banner-button[data-slide-index=" + this.swiper.realIndex + "]").addClass(IS_ACTIVE_CLASS);
    },

    getNextItemIndex() {
        if (!this.swiper || !this.cards?.length) {
            return 0;
        }

        const nextItemIndex = this.swiper.realIndex + 1;
        return nextItemIndex >= this.cards.length ? 0 : nextItemIndex;
    },

    pauseActiveVideo() {
        const videoPlayers = this.$heroBanner.find("brightcove-video");
        if (videoPlayers.length && videojs) {
            videoPlayers.each((_, player) => {
                const videoId = $(player).find(".video-js")[0].getAttribute("id");
                const videoPlayer = videojs.getPlayer(videoId);

                if (videoPlayer) {
                    if (!videoPlayer.paused() && videoPlayer.readyState() > 0) {
                        videoPlayer.pause();
                    }
                }
            });
        }
    }
});
